export default function CustomerPointsChangeStatusController(
  $state,
  $stateParams,
  customersService,
  NotificationService,
  notificationHelper,
  POINT_STATUSES,
) {
  var vm = this;

  vm.isLoading = false;
  vm.customerId = $stateParams.customerId;
  vm.customer = $stateParams.customer;
  vm.point = $stateParams.point;
  vm.pointStatuses = POINT_STATUSES;
  vm.accountTransfer = {
    status: vm.point ? vm.point.status : '',
    reason: vm.point ? vm.point.reason : '',
  };

  vm.changeStatus = changeStatus;

  function changeStatus() {
    if (vm.isLoading || !vm.point) {
      return;
    }
    enableLoading();
    customersService
      .updateAccountTransferStatus(vm.customerId, vm.point.id, vm.accountTransfer.status, vm.accountTransfer.reason)
      .then(function() {
        $state.go(
          'app.customers.edit',
          {
            customerId: vm.customerId,
            tab: 'points',
          },
          { reload: true },
        );
      })
      .then(function() {
        NotificationService.success('Points status successfully updated');
      })
      .catch(function(res) {
        notificationHelper.showError(res, 'Error updating points status');
      })
      .finally(disableLoading);
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/points/change-status.controller.js